import { httpClient } from '../../services/http-client'
import { DataSubscription } from "../../models/data-subscriptions/data-subscription"
import { Invoice } from "../../models/invoice"

class DataSubscriptionsApi {
    subscriptions() {
        return httpClient
            .get('/datasubscriptions')
            .then(res => {
                return res.data as DataSubscription[]
            })
    }

    invoices(subId: string) {
        return httpClient
            .get('/datasubscriptions/invoices-with-receipt/' + subId)
            .then(res => {
                return res.data as Invoice[]
            })
    }

    get(subId: number) {
        return httpClient
            .get('/datasubscriptions/' + subId)
            .then(res => {
                return res.data
            })
    }

    cancel(subId: number) {
        return httpClient
            .post('/datasubscriptions/cancel/' + subId)
            .then(res => {
                return res
            })
    }

    select(subId: number) {
        return httpClient
            .post('/datasubscriptions/select/' + subId)
            .then(res => {
                return res.data
            })
    }

    rename(subId: number, name: string) {
        return httpClient
            .post('/datasubscriptions/rename/' + subId, { name })
            .then(res => {
                return res
            })
    }

    update(subId: number, data) {
        return httpClient
            .post('/datasubscriptions/' + subId + '/update-codes', data )
            .then(res => {
                return res
            })
    }
}

export const dataSubscriptionsApi = new DataSubscriptionsApi()
